/**
 * Time granularity options for dashboard charts
 */
export type TimeGranularity = "daily" | "weekly" | "monthly" | "quarterly";

/**
 * Format a period key (ISO date string) into a human-readable label
 * based on the granularity level
 */
export function formatPeriodLabel(
  periodKey: string,
  granularity: TimeGranularity,
): string {
  const date = new Date(periodKey);

  switch (granularity) {
    case "daily":
      return date.toLocaleDateString("de-DE");
    case "weekly": {
      // Calculate week number
      const startOfYear = new Date(date.getFullYear(), 0, 1);
      const days = Math.floor(
        (date.getTime() - startOfYear.getTime()) / (24 * 60 * 60 * 1000),
      );
      const weekNum = Math.ceil((days + startOfYear.getDay() + 1) / 7);
      return `KW ${weekNum}, ${date.getFullYear()}`;
    }
    case "monthly": {
      const monthNames = [
        "Jan",
        "Feb",
        "Mär",
        "Apr",
        "Mai",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Okt",
        "Nov",
        "Dez",
      ];
      return `${monthNames[date.getMonth()]} ${date.getFullYear()}`;
    }
    case "quarterly": {
      const quarter = Math.floor(date.getMonth() / 3) + 1;
      return `Q${quarter} ${date.getFullYear()}`;
    }
    default:
      return date.toLocaleDateString("de-DE");
  }
}
